import './style.scss';
import imgUrl from '../../images/bg-share.png';

export default () => {
  return `<div class="content-default"><img src="${imgUrl}" alt=""></div>`;
};
